"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _wtbUtils = require("wtb-utils");

// Remove accents, ending and starting blank spaces and turns string to lower case
function cleanString() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (!str || typeof str !== 'string') {
    _wtbUtils.Logger.error("cleanString parameter must exist and be a string. Now it is ".concat((0, _typeof2["default"])(str)));

    return '';
  }

  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
}

var _default = cleanString;
exports["default"] = _default;